import React from "react"

const Paginator = ({ lastPage, currentPage, onPageChange, offset = 5 }) => {
  const handlePageChange = (page) => {
    onPageChange(page)
  }

  const moveToFirstPage = () => {
    onPageChange(1)
  }

  const moveToLastPage = () => {
    onPageChange(lastPage)
  }

  const moveForward = () => {
    const adjustment = currentPage < offset ? offset - currentPage : 0
    const newPage = Math.min(currentPage + offset + adjustment, lastPage)
    onPageChange(newPage)
  }

  const moveBackward = () => {
    const adjustment = currentPage > lastPage - offset ? currentPage - (lastPage - offset) - 1 : 0
    const newPage = Math.max(currentPage - offset - adjustment, 1)
    onPageChange(newPage)
  }

  const renderPageNumbers = () => {
    const pages = []
    for (let i = 1; i <= lastPage; i++) {
      const isActive = currentPage === i
      let isVisible = false

      if (currentPage <= offset && i <= offset * 2 - 1) {
        isVisible = true
      } else if (currentPage > lastPage - offset && i > lastPage - (offset * 2 - 1)) {
        isVisible = true
      } else {
        isVisible = Math.abs(i - currentPage) < offset
      }

      if (isVisible) {
        pages.push(
          <div key={i} className={`p-[15px] page-item cursor-pointer ${isActive ? "active text-black" : "text-gray-400"} hover:text-black`} onClick={() => handlePageChange(i)}>
            <button className="page-link">{i}</button>
          </div>
        )
      }
    }
    return pages
  }

  return (
    <div className="pagination flex flex-row mx-auto justify-center">
      {currentPage > 1 && (
        <>
          <div className="p-[15px] page-item cursor-pointer text-gray-400 hover:text-black" onClick={moveToFirstPage}>
            <button className="page-link" aria-label="First Page">
              &#171;
            </button>
          </div>
          <div className="p-[15px] page-item cursor-pointer text-gray-400 hover:text-black" onClick={moveBackward}>
            <button className="page-link" aria-label="Previous Page">
              &#8249;
            </button>
          </div>
        </>
      )}

      {renderPageNumbers()}

      {currentPage < lastPage && (
        <>
          <div className="p-[15px] page-item cursor-pointer text-gray-400 hover:text-black" onClick={moveForward}>
            <button className="page-link" aria-label="Next Page">
              &#8250;
            </button>
          </div>
          <div className="p-[15px] page-item cursor-pointer text-gray-400 hover:text-black" onClick={moveToLastPage}>
            <button className="page-link" aria-label="Last Page">
              &#187;
            </button>
          </div>
        </>
      )}
    </div>
  )
}

export default Paginator
